import { CommentsIcon, InboxIcon, PaperPlaneIcon, PhoneIcon, UserFriendsIcon } from '@forgeglobal/design-framework'
import React from 'react'

export const getInteractionIcon = (tpe: string, isInbound: boolean = false) => {
  switch (tpe) {
    case 'phone_call':
      return <PhoneIcon />
    case 'email':
      return isInbound ? <InboxIcon /> : <PaperPlaneIcon />
    case 'in_person':
      return <UserFriendsIcon />
    case 'messaging':
      return <CommentsIcon />
    default:
      return <CommentsIcon />
  }
}
